import { Box, Typography } from '@mui/material';
import { SimpleLinkField } from 'framework/ViewTypes';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useRecruitmentPoolUrl } from 'domain/recruiting/recruitmentPool/routing';
import { SourcingFilterOptions } from '../../../types';

const SouringTitle = ({
  filterOptions,
  appliedSavedFilterName,
}: {
  filterOptions: SourcingFilterOptions;
  appliedSavedFilterName?: string;
}) => {
  const { getSingleEntityUrl } = useRecruitmentPoolUrl();

  return (
    <>
      <SimpleLinkField
        to={getSingleEntityUrl(filterOptions.id)}
        value={filterOptions.poolName}
        sx={{ typography: 'h6' }}
      />
      {appliedSavedFilterName ? (
        <>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              height: 36,
              display: 'inline-flex',
              alignItems: 'center',
              color: 'primary.main',
              borderRadius: 1,
              backgroundColor: 'background.brandSubtle',
              px: 2,
              gap: 1,
            }}
          >
            <FilterListIcon />
            <Typography variant="subtitle1">{`Saved filter: ${appliedSavedFilterName}`}</Typography>
          </Box>
          :
        </>
      ) : null}
    </>
  );
};

export default SouringTitle;
